export const assetPath = {
    path: "https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets"
};
